app.service("StaffService", ['$rootScope', function ($rootScope) {

    const service = this;

    const StaffCustomerEntryModel = function () {
        this.is_staff = false;
        this.is_rep = false;
        this.is_staff_or_rep = false;
        this.is_primary_test_account = false;
        this.is_complete_test_account = false;
        this.staff_rep_customer_code = null;
    };


    this.model = new StaffCustomerEntryModel();
    const model = this.model;

    service.applyUserDataToStaff = function (userData, callback) {
        model.is_staff = userData.user_type === "staff";
        model.is_rep = userData.user_type === "rep";
        model.is_primary_test_account = userData.username === "test@bacomponents.co.uk";
        model.is_complete_test_account = userData.username === "completetest@byba.co.uk";
        if (model.is_staff) {
            localStorage.setItem("is_staff", "1");
        } else {
            localStorage.removeItem("is_staff");
        }
        if (model.is_rep) {
            localStorage.setItem("is_rep", "1");
        } else {
            localStorage.removeItem("is_rep");
        }
        if (model.is_primary_test_account) {
            localStorage.setItem("is_primary_test_account", "1");
        } else {
            localStorage.removeItem("is_primary_test_account");
        }
        if (model.is_complete_test_account) {
            localStorage.setItem("is_complete_test_account", "1");
        } else {
            localStorage.removeItem("is_complete_test_account");
        }
        model.is_staff_or_rep = model.is_staff || model.is_rep;
        if (!model.is_staff_or_rep || !model.staff_rep_customer_code) {
            if (callback) {
                callback(true)
            }
        } else {
            service.requestCustomerData(model.staff_rep_customer_code, callback);
        }

    }


    this.requireCurrentOrderCustomer = function (callback) {

        const currentOrder = $rootScope.model.order.current_order;

        if (!currentOrder || !model.is_staff_or_rep || !currentOrder.customer_code || currentOrder.customer_code === model.staff_rep_customer_code) {
            if (callback) {
                callback()
            }
        }
        service.setStaffRepCustomerCode(currentOrder.customer_code, callback)
    }


    this.setStaffRepCustomerCode = function (staffRepCustomerCode, callback) {
        const isStaffOrRep = model.is_staff_or_rep;
        model.staff_rep_customer_code = staffRepCustomerCode && isStaffOrRep ? staffRepCustomerCode : null;

        if (staffRepCustomerCode) {
            localStorage.setItem('staff_rep_customer_code', staffRepCustomerCode);
        } else {
            localStorage.removeItem('staff_rep_customer_code');
        }

        if (staffRepCustomerCode) {
            service.requestCustomerData(staffRepCustomerCode, callback);
        } else {
            if (isStaffOrRep) {
                $rootScope.service.account.applyCustomerData(null);
                $rootScope.service.order.startNewOrder();
            }
            if (callback) {
                callback(false);
            }
        }
    }

    this.requestCustomerData = function (customerCode, callback) {

        function handleCallback(success, customerData, messages) {
            if (callback) {
                callback(success, customerData, messages)
            }
        }

        if (!customerCode) {
            handleCallback(false)
            return;
        }

        let isCurrentCustomer = isCurrentCustomerCode(customerCode);

        const endpoint = '/request/api.php/customers/' + customerCode + '?include_zero_discounts=true';
        $rootScope.service.request.getRequest(endpoint, function (success, customerData, messages) {


            if (isCurrentCustomer && !isCurrentCustomerCode(customerCode)) {
                success = false;
                isCurrentCustomer = false;
            }

            if (success) {
                $rootScope.service.currency.requireCurrency(customerData.currency, function (currencySuccess, currencyData) {
                    success = currencySuccess;

                    if (success) {
                        customerData.currencyData = currencyData;
                    }
                    if (isCurrentCustomer && !isCurrentCustomerCode(customerCode)) {
                        success = false;
                        isCurrentCustomer = false;
                    }

                    if (isCurrentCustomer && success) {
                        $rootScope.service.account.applyCustomerData(customerData);
                    }

                    handleCallback(success, customerData, messages);
                });
            } else {
                handleCallback(false, customerData, messages);
            }
        });
    }


    this.transferCart = function (order, transferUserID, transferEmail, transferURL, callback) {

        order = JSON.parse(JSON.stringify(order));

        const endpoint = '/request/api.php/orders/'+order._id+'/transfer';
        order.transfer_user_id = parseInt(transferUserID);
        if(transferEmail){
            order.transfer_email = transferEmail;
        } else {
            delete order.transfer_email;
        }
        order.transfer_url = transferURL;
        $rootScope.service.request.postJsonRequest(endpoint, order, function (success, response, messages) {
            callback(success, messages)
        })
    }

    service.isSelectCustomerRequired = function () {
        return model.is_staff_or_rep && !model.staff_rep_customer_code;
    }

    function isCurrentCustomerCode(customerCode) {
        return customerCode === model.staff_rep_customer_code
    }

    function parseStaffRepCustomerCode() {
        model.staff_rep_customer_code = localStorage.getItem('staff_rep_customer_code');
        model.staff_rep_customer_code = model.staff_rep_customer_code ? model.staff_rep_customer_code : null;
    }

    this.indexInit = function () {
        parseStaffRepCustomerCode()
    }

}]);